(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bicc-club-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bicc-club-video-play]').forEach(function(button) {
  button.addEventListener('click', function() {
    var iframe = document.createElement('iframe');
    iframe.src = button.dataset.embedUrl;
    iframe.title = button.getAttribute('aria-label') || '';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    button.replaceWith(iframe);
  }, { once: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bicc-product-details"]) return;
  try {
    
function biccNormalisePlainProductDescription() {
  document.querySelectorAll('.bicc-product-details__description').forEach((container) => {
    if (container.querySelector('p, ul, ol, h2, h3')) return;

    const text = container.innerText.replace(/\u00a0/g, ' ').replace(/[ \t]+\n/g, '\n').trim();
    if (!text) return;

    let blocks = text
      .split(/\n\s*\n|\n+/)
      .map((block) => block.replace(/\s+/g, ' ').trim())
      .filter(Boolean);

    if (blocks.length === 1 && blocks[0].length > 360) {
      blocks = biccBuildDescriptionChunks(blocks[0]);
    }

    if (!blocks.length) return;

    container.replaceChildren();
    blocks.forEach((block) => {
      const paragraph = document.createElement('p');
      paragraph.textContent = block;
      container.appendChild(paragraph);
    });
  });
}

function biccBuildDescriptionChunks(text) {
  const sentences = text.match(/[^.!?]+[.!?]+(?:[”’"')\]]*)|[^.!?]+$/g);
  if (!sentences || sentences.length < 2) return [text];

  const chunks = [];
  let current = '';

  sentences.forEach((sentence) => {
    const clean = sentence.replace(/\s+/g, ' ').trim();
    if (!clean) return;

    if (current && current.length + clean.length + 1 > 300) {
      chunks.push(current);
      current = clean;
    } else {
      current = current ? current + ' ' + clean : clean;
    }
  });

  if (current) chunks.push(current);
  return chunks.length > 1 ? chunks : [text];
}

function biccProductDescriptionLabels() {
  document.querySelectorAll('.bicc-product-details__description p').forEach((paragraph) => {
    const paragraphText = paragraph.textContent.replace(/\s+/g, ' ').trim();
    if (!paragraphText) return;

    const strong = paragraph.querySelector(':scope > strong');
    const strongText = strong ? strong.textContent.replace(/\s+/g, ' ').trim() : '';

    if ((strongText && paragraphText === strongText) || /^STYLE:\s*/i.test(paragraphText)) {
      paragraph.classList.add('bicc-product-description__label');
    }
  });
}

function biccSplitLongProductParagraphs() {
  document.querySelectorAll('.bicc-product-details__description p').forEach((paragraph) => {
    if (paragraph.classList.contains('bicc-product-description__label')) return;

    const text = paragraph.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    if (text.length <= 360) return;

    if (paragraph.querySelector('a, img, br')) return;

    const meaningfulFormatting = Array.from(paragraph.querySelectorAll('strong, em'))
      .some((element) => element.textContent.replace(/\s+/g, ' ').trim().length > 0);
    if (meaningfulFormatting) return;

    const chunks = biccBuildDescriptionChunks(text);
    if (chunks.length < 2) return;

    const fragment = document.createDocumentFragment();
    chunks.forEach((chunk) => {
      const nextParagraph = document.createElement('p');
      nextParagraph.textContent = chunk;
      fragment.appendChild(nextParagraph);
    });

    paragraph.replaceWith(fragment);
  });
}

function biccBeerDescriptionCleanup() {
  document.querySelectorAll('.bicc-product-details--beer .bicc-product-details__description p').forEach((paragraph) => {
    const text = paragraph.textContent.replace(/\s+/g, ' ').trim();
    const upper = text.toUpperCase();
    const isStructuredLine =
      upper.startsWith('GRAIN:') ||
      upper.startsWith('YEAST:') ||
      upper.startsWith('BRUNY ISLAND CHEESE MATCH:') ||
      upper.startsWith('HOPS:') ||
      /^\d+(?:\.\d+)?%\s*A\/V\.?$/i.test(text);

    if (isStructuredLine) {
      paragraph.remove();
    }
  });
}

function biccInitialiseProductDescriptions() {
  biccNormalisePlainProductDescription();
  biccProductDescriptionLabels();
  biccSplitLongProductParagraphs();
  biccBeerDescriptionCleanup();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', biccInitialiseProductDescriptions);
} else {
  biccInitialiseProductDescriptions();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function() {
  var filterConfig = {
    'cheese': ['availability', 'price', 'range type', 'cheese milk source', 'milk source', 'cheese milk treatment', 'milk treatment', 'cheese texture', 'texture', 'cheese rind style', 'rind style', 'cheese maturation', 'maturation'],
    'our-raw-cheeses': ['availability', 'price', 'range type', 'cheese milk source', 'milk source', 'cheese texture', 'texture', 'cheese rind style', 'rind style', 'cheese maturation', 'maturation'],
    'beer': ['availability', 'price', 'range type', 'beer style', 'beer profile', 'abv'],
    'pantry': ['availability', 'price', 'vendor', 'pantry type', 'range type'],
    'tasmanian': ['availability', 'price', 'vendor', 'pantry type', 'range type'],
    'tasmanian-wines-spirits': ['availability', 'price', 'vendor', 'wine style', 'grape variety', 'wine region', 'wine vintage', 'vintage', 'spirit type', 'spirit base', 'signature ingredient/base', 'abv'],
    'our-hampers': ['availability', 'price', 'hamper contents', 'build your own'],
    'cheese-hampers': ['availability', 'price', 'hamper contents', 'build your own'],
    'build-your-own-hampers': ['availability', 'price', 'hamper contents', 'build your own'],
    'mixed-beer-packs': ['availability', 'price'],
    'subscriptions': ['availability', 'price'],
    'all-products': ['availability', 'price', 'vendor', 'product type', 'shop category', 'range type']
  }

  function getRoot() {
    return document.querySelector('.collection-content[data-bicc-collection-handle]');
  }

  function labelMatches(label, allowed) {
    return allowed.some(function(key) {
      return label === key || label.indexOf(key) !== -1;
    });
  }

  function getFilterKey(group) {
    var label = (group.dataset.biccFilterLabel || '').trim().toLowerCase();
    var param = (group.dataset.biccFilterParam || '').trim().toLowerCase();

    if (param === 'filter.p.vendor') return 'vendor';
    if (param === 'filter.p.product_type') return 'product type';
    if (param === 'filter.v.availability') return 'availability';
    if (param.indexOf('filter.v.price') === 0) return 'price';
    if (param === 'filter.p.m.custom.shop_category') return 'shop category';

    return label;
  }

  function optimiseFilters() {
    var root = getRoot();
    if (!root) return;
    var allowed = filterConfig[root.dataset.biccCollectionHandle];
    if (!allowed) return;

    root.querySelectorAll('[data-bicc-filter-label]').forEach(function(group) {
      var key = getFilterKey(group);
      group.hidden = !labelMatches(key, allowed);
    });
  }

  function sortSoldOuts() {
    var root = getRoot();
    if (!root) return;

    root.querySelectorAll('.grid--uniform').forEach(function(grid) {
      var items = Array.prototype.filter.call(grid.children, function(item) {
        return item.classList.contains('grid-product') && item.hasAttribute('data-bicc-available');
      });

      if (!items.length) return;

      var available = items.filter(function(item) {
        return item.dataset.biccAvailable === 'true';
      });
      var soldOut = items.filter(function(item) {
        return item.dataset.biccAvailable !== 'true';
      });
      var sorted = available.concat(soldOut);
      var alreadySorted = items.every(function(item, index) {
        return item === sorted[index];
      });

      if (!alreadySorted) {
        sorted.forEach(function(item) {
          grid.appendChild(item);
        });
      }
    });
  }

  function refreshEnhancements() {
    optimiseFilters();
    sortSoldOuts();
  }

  document.addEventListener('change', function(event) {
    var variantSelect = event.target.closest('[data-bicc-variant-select]');
    if (!variantSelect) return;

    var dialog = variantSelect.closest('[data-bicc-quick-add-dialog]');
    if (!dialog) return;

    dialog.querySelectorAll('[data-bicc-plan-select]').forEach(function(select) {
      var active = select.dataset.variantId === variantSelect.value;
      select.hidden = !active;
      select.disabled = !active;
    });
  });

  document.addEventListener('click', function(event) {
    var openButton = event.target.closest('[data-bicc-open-quick-add]');
    if (openButton) {
      event.preventDefault();
      var dialog = document.getElementById(openButton.dataset.biccOpenQuickAdd);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    var closeButton = event.target.closest('[data-bicc-close-quick-add]');
    if (closeButton) {
      var closeDialog = closeButton.closest('[data-bicc-quick-add-dialog]');
      if (closeDialog && closeDialog.open) closeDialog.close();
      return;
    }

    if (event.target.matches('[data-bicc-quick-add-dialog]') && event.target.open) {
      event.target.close();
      return;
    }

    var link = event.target.closest('[data-bicc-load-more] [data-bicc-next-url]');
    if (!link) return;

    event.preventDefault();

    var root = getRoot();
    if (!root || link.dataset.biccLoading === 'true') return;

    link.dataset.biccLoading = 'true';
    var label = link.querySelector('[data-bicc-load-more-text]');
    var originalLabel = label ? label.textContent : '';
    if (label) label.textContent = root.dataset.biccLoadingText || originalLabel;

    var nextUrl = new URL(link.dataset.biccNextUrl || link.href, window.location.origin);
    var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewThemeId && !nextUrl.searchParams.has('preview_theme_id')) {
      nextUrl.searchParams.set('preview_theme_id', previewThemeId);
    }

    fetch(nextUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to load more products');
        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('#CollectionAjaxContent .grid--uniform');
        var currentGrid = root.querySelector('.grid--uniform');
        if (!nextGrid || !currentGrid) throw new Error('Product grid not found');

        Array.prototype.slice.call(nextGrid.children).forEach(function(item) {
          currentGrid.appendChild(item);
        });

        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
        } else {
          currentGrid.querySelectorAll('[data-aos]').forEach(function(element) {
            element.classList.add('aos-animate');
          });
        }

        var nextLink = doc.querySelector('[data-bicc-load-more] [data-bicc-next-url]');
        if (nextLink) {
          link.dataset.biccNextUrl = nextLink.dataset.biccNextUrl || nextLink.getAttribute('href');
          link.setAttribute('href', nextLink.getAttribute('href'));
          link.dataset.biccLoading = 'false';
          if (label) label.textContent = originalLabel;
        } else {
          var wrapper = link.closest('[data-bicc-load-more]');
          if (wrapper) wrapper.remove();
        }

        refreshEnhancements();
      })
      .catch(function() {
        link.dataset.biccLoading = 'false';
        if (label) label.textContent = originalLabel;
        window.location.href = link.href;
      });
  });

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('.bicc-quick-add-form');
    if (!form) return;

    event.preventDefault();

    var root = getRoot();
    var button = form.querySelector('.bicc-quick-add-button');
    var status = form.querySelector('.bicc-quick-add-status');
    if (!button || button.disabled) return;

    var originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = root && root.dataset.biccAddingText ? root.dataset.biccAddingText : originalLabel;

    var action = form.action;
    if (action.slice(-3) !== '.js') action += '.js';

    fetch(action, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(data) { throw data; });
        return response.json();
      })
      .then(function(data) {
        document.querySelectorAll('.cart-link__bubble').forEach(function(bubble) {
          bubble.classList.add('cart-link__bubble--visible');
        });

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data }
        }));

        if (status) status.textContent = root && root.dataset.biccAddedText ? root.dataset.biccAddedText : '';

        var dialog = form.closest('[data-bicc-quick-add-dialog]');
        if (dialog && dialog.open) dialog.close();
      })
      .catch(function() {
        if (status) status.textContent = root && root.dataset.biccAddErrorText ? root.dataset.biccAddErrorText : '';
      })
      .finally(function() {
        button.disabled = false;
        button.textContent = originalLabel;
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshEnhancements);
  } else {
    refreshEnhancements();
  }

  var queued = false;
  var observer = new MutationObserver(function() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function() {
      queued = false;
      refreshEnhancements();
    });
  });

  var observerRoot = getRoot();
  if (observerRoot) observer.observe(observerRoot, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
